export default {
  form: {
    gtin: {
      label: 'GTIN',
    },
    product_type: {
      label: 'Produkttyp',
      options: {
        packaged: 'Verpackt',
        prepared: 'Zubereitet',
      },
    },
    pfand: { label: 'Pfand' },
    packaging_material: {
      label: 'Verpackungsmaterial',
    },
    brand_or_manufacturer: {
      label: 'Marke oder Hersteller',
    },
    net_quantity: {
      label: 'Nettomenge',
    },
    base_price: {
      label: 'Festpreis pro Einheit (z. B. pro Liter für ein Getränk)',
      placeholder: 'Preis pro Einheit',
    },
    alcohol_by_volume_percent: {
      label: 'Alkoholgehalt',
    },
    caffeine_mg_per_100ml: {
      label: 'Koffein (mg pro 100 ml Produkt)',
    },
    ingredients_text: {
      label: 'Zutaten',
    },
    allergens_list: {
      label: 'Allergene',
    },
    additives_list: {
      label: 'Zusatzstoffe',
    },
    has_nutrition_table: {
      label: 'Nährwerttabelle ausfüllen (pro 100{{unit}} des Produkts)',
    },
    energy_kj: {
      label: 'Energie (kJ)',
    },
    energy_kcal: {
      label: 'Energie (kcal)',
    },
    fat_g: {
      label: 'Fett',
    },
    saturates_g: {
      label: 'Sättigt',
    },
    carbohydrate_g: {
      label: 'Kohlenhydrat',
    },
    sugars_g: {
      label: 'Zucker',
    },
    protein_g: {
      label: 'Protein',
    },
    salt_g: {
      label: 'Salz',
    },
    identifiers: {
      label: 'Kennzeichnungen',
    },
  },
};
